<mat-toolbar class="header">
  <div class="animated-gradient-box" (click)="goHome()">
  </div>
  <span class="spacer"></span>
  <span class="nav-buttons">
    
    <ng-container *ngIf="user$ | async as user; else notSignedIn">
      <button mat-mini-fab class="metallic-bubble-btn-green" [matMenuTriggerFor]="menu">
          <span>{{ userInitials }}</span>
      </button>
      <mat-menu #menu="matMenu" class="nav-user-menu white-blur">
        <div class="nav-user-info">
            <div class="user_name">
              {{ user.firstName }} {{ user.lastName }}
            </div>
            <div class="user_id">
              {{ user.username }}
            </div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="goToAdmin()" *ngIf="user.role === 'admin'"><mat-icon>shield</mat-icon>Admin</button>
        <button mat-menu-item (click)="goToSalesDashboard()" *ngIf="['admin', 'sales'].includes(user.role)"><mat-icon>analytics</mat-icon>Sales Dashboard</button>
        <button mat-menu-item (click)="goToProfile()"><mat-icon>account_circle</mat-icon>Profile</button>
        <button mat-menu-item (click)="openLikes()"><mat-icon>favorite</mat-icon>Saved Properties</button>
        <button mat-menu-item (click)="goToManageProperties()"><mat-icon>bungalow</mat-icon>Manage Properties</button>
        <button mat-menu-item (click)="logout()"><mat-icon>logout</mat-icon>Logout</button>
      </mat-menu>
    </ng-container>
    <ng-template #notSignedIn>
      <button mat-flat-button class="metallic-text-btn" (click)="openLogin()">LOGIN</button>
    </ng-template>
  </span>
</mat-toolbar>